var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-overview"},[_c('Header'),_c('div',{staticClass:"v-overview__content container"},[_c('Overview',{staticClass:"mt--4"})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }